import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar";
import Header from "../Header";
import { Container, StyledMainContainer } from "./styles";
import { selectUserLoginState } from "../../config/redux/slices/userSlice/selectors";
import { useSelector } from "react-redux";

const Layout = () => {
  const navigate = useNavigate();
  const isUserLoggedIn = useSelector(selectUserLoginState);
  const [showSidebar, setShowSidebar] = React.useState(false);

  const toggleSidebar = () => setShowSidebar((prev) => !prev);

  useEffect(() => {
    if (!isUserLoggedIn) {
      navigate("/login", { replace: true });
    }
  }, [isUserLoggedIn, navigate]);

  return isUserLoggedIn ? (
    <Container>
      <Header toggleSidebar={toggleSidebar} />
      <div>
        <Sidebar show={showSidebar} toggleSidebar={toggleSidebar} />
        <StyledMainContainer>
          <Outlet />
        </StyledMainContainer>
      </div>
    </Container>
  ) : (
    <></>
  );
};

export default Layout;
